import router from "@/router";
import Element from "element-ui"
import api from "@/api/index.js"
const TokenKey = "Admin-Token"
const adminKey = "Admin-Info"
import { message } from '@/utils/resetMessage'
export default{
	//用户状态有误跳转
	unLoginJump(){
		var msg = "登录状态已失效";
		var token = this.getToken();
		if(token==null || token==""){
			message.error(msg)
			router.push({path:'/login'})
		}else{
			api.loadUserInfo().then(res=>{
				if(res.code==0){
					this.setAdminInfo(JSON.stringify(res.user));
				}else{
					message.error(msg)
					router.push({path:'/login'})
				}
			}).catch(res=>{
				message.error(msg)
				router.push({path:'/login'})
			})
			
		}
	},
	/**
	 * 获取管理员token
	 */
	getToken() {
	  return localStorage.getItem(TokenKey);
	},
	/**
	 * 设置token
	 */
	setToken(token) {
	  return localStorage.setItem(TokenKey,token);
	},
	/**
	 * 移除token
	 */
	removeToken() {
		localStorage.removeItem(TokenKey);
	},
	getAdminInfo(){
		return localStorage.getItem(adminKey);
	},
	setAdminInfo(data) {
	  return localStorage.setItem(adminKey,data);
	},
	/**
	 * 移除token
	 */
	removeAdminInfo() {
		localStorage.removeItem(adminKey);
	},
	/**
	 * 判断权限是否存在
	 * @param {Object} value
	 */
	checkPerms(value){
		var perms = localStorage.getItem("perms");
		if(perms.indexOf(value)>-1){
			return true
		}else{
			return false
		}
	}
	
}